import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../general.service';
import { DataService } from '../data.service';
import {TranslateService} from '@ngx-translate/core';

declare var Hashes: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: [
    './login.component.scss'
  ]
})

export class LoginComponent implements OnInit {

  public logo = "";
  public errorText = "";
  public displayError = false;
  public Username = "";
  public Name = "";
  public Password = "";
  public loginDisabled = false;
  public languageSelected = "en";
  public showMockLogin = false;
  public showMockUsername = false;
  public showMockName = false;
  public mockExamId = 0;
  public kioskWarning = true;
  public isLoading = true;
  public exiting = false;

  constructor(
    public generalSvc: GeneralService,
    public dataSvc: DataService,
    public translate: TranslateService
  ) {
    // Set default values;
    this.Username = "";
    this.Password = "";
    this.Name = "";

    this.onLoad();
  }
  

  ngOnInit() {
    var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
      this.dataSvc.changeLangauge(exisitingLangauge);      
    }
    else{
      this.translate.setDefaultLang("en");
      this.translate.use("en");
      exisitingLangauge = "en";
    }
    this.languageSelected = exisitingLangauge;  
  }

  changeLangauge(language){
    localStorage.setItem("userslanguage", language.toString());
    this.translate.setDefaultLang(language.toString());
    this.translate.use(language.toString());
    this.languageSelected = language.toString();  
  }  

  onLoad() {
    var urlParams = new URLSearchParams(window.location.search);
    var username = urlParams.get('qs');
    var token = urlParams.get('a');
    var scheduleId = urlParams.get('sid');
    var kiosk = urlParams.get('kiosk');

    var kioskSetting = localStorage.getItem("kioskSetting");
    if (kioskSetting != null && kioskSetting != undefined) {
      kiosk = "1";
    }

    this.checkKiosk(kiosk);

    if(token !== "" && token !== null && token !== undefined){    
      if(username !== null && username !== undefined && username !== ""){
        this.dataSvc.initSSOLogin(username, token);
      }
    } else if(scheduleId !== null && scheduleId !== "" && scheduleId !== undefined){    
      if(username !== null && username !== undefined && username !== ""){
        this.dataSvc.initBMSLogin(username, scheduleId);
      }
    }

    var errorParam = this.generalSvc.getUrlParam("err");

    if (errorParam === 0) {
      this.errorText = "You entered incorrect login details.";
      this.displayError = true;
    }
    else if (errorParam == 1) {
      this.errorText = "Please login to eNetAssess.";
      this.displayError = true;
    }
    else {
      this.displayError = false;
    }

    var mockParam = this.generalSvc.getUrlParam("mock");
    if(mockParam == 1){
      this.showMockLogin = true;
      var mockIdParam = this.generalSvc.getUrlParam("mid") as number;
      if(mockIdParam !== null && mockIdParam !== undefined){
        this.mockExamId = mockIdParam;
        var mockUsernameParam = this.generalSvc.getUrlParam("mu");
        if(mockUsernameParam !== null && mockUsernameParam !== undefined && mockUsernameParam === "1"){
          this.showMockUsername = true;
        }
        else{
          this.showMockUsername = false;
        }
        var mockUsersNameParam = this.generalSvc.getUrlParam("mn");
        if(mockUsersNameParam !== null && mockUsersNameParam !== undefined && mockUsersNameParam === "1"){
          this.showMockName = true;
        }
        else{
          this.showMockName = false;
        }
      }
    }
    else{
      this.showMockLogin = false;
    }

  }

  checkKiosk(kiosk) {
    console.log("Checking kiosk");
    if (this.dataSvc.kioskMode == null || this.dataSvc.kioskMode == undefined) {
      console.log("No datasvc kiosk mode set");
      setTimeout(function(){
        this.checkKiosk(kiosk);
      }, 1000);
    } else {
      setTimeout(() => {
        console.log("Datasvc kiosk mode found");
        if (kiosk == null || kiosk == undefined || kiosk == "") {
          console.log("Kiosk not set");
          // No kiosk - check if Kiosk is forced;
          var kioskEnabled = this.dataSvc.kioskMode;
          console.log("Kiosk mode set to: ", kioskEnabled);
          if (kioskEnabled) {
            this.kioskWarning = true;
            this.isLoading = false;
          } else {
            localStorage.removeItem("kioskSetting");
            this.kioskWarning = false;
            this.isLoading = false;
          }
        } else {
          console.log("Setting kiosk is toggled");
          localStorage.setItem("kioskSetting", "1");
          this.kioskWarning = false;
          this.isLoading = false;
        }
      }, 1000);
    }
  }

  downloadEnetSecure() {
    window.location.href = this.dataSvc.kioskDownload;
  }

  getMembership(pass, salt) {
      var SHA1 = new Hashes.SHA1().b64(pass);
      var SHA1ws = new Hashes.SHA1().b64_hmac(pass, salt);
      return SHA1ws;
  }

  checkLogin() {
    if (this.Username.indexOf("demo") > -1)
      this.Username = "demo";

    this.dataSvc.initLogin(this.Username, this.Password);
  }

  checkMockLogin() {
    if (this.Username === "")
      this.Username = "mockuser";

      if (this.Name === "")
        this.Name = "Mock User";
      this.Password = "12345"

    this.dataSvc.initMockLogin(this.Username, this.Password, this.mockExamId, this.Name );
  }

  processLogin(query) {
    var scQuery = query.replace(/\+/g, "###plus###");
  }

  submitLogin() {
    this.loginDisabled = true;
    this.checkLogin();

    setTimeout(() => {
      this.loginDisabled = false;
    }, 2500);
  }

  submitMockLogin() {
    this.loginDisabled = true;
    this.checkMockLogin();

    setTimeout(() => {
      this.loginDisabled = false;
    }, 2500);
  }

  exitenetsecure(){
    this.exiting = true;
    window.location.href = this.dataSvc.bmsUrl;
  }
}